export const bankOfEnglandBaseRate = {
  heading: 'bank-of-england-base-rate-page-heading',
  sectionHeading: 'bank-of-england-base-rate-heading',
  sectionBody: 'bank-of-england-base-rate-section-body',
};
